import React, { useState } from "react";
import PropTypes from "prop-types";
import { Select } from "@opendate-app/setlist";
import CheckoutEmbedModal from "../shared/CheckoutEmbedModal/CheckoutEmbedModal";
import { classesEmbedIframeId, classesEmbedUrl } from "./classesEmbed";
import "./classesEmbedModal.css";

const optionShape = PropTypes.shape({
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
});

export const embedFilterShape = PropTypes.shape({
  param: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(optionShape).isRequired,
  multiple: PropTypes.bool,
  placeholder: PropTypes.string,
});

export default function ClassesEmbedModal({ open, onClose, venues, filters }) {
  const [venueId, setVenueId] = useState(String(venues[0]?.id));
  const [values, setValues] = useState({});
  const venue = venues.find((candidate) => String(candidate.id) === venueId) || venues[0];

  if (!venue) return null;

  const setValue = (param, value) => setValues((current) => ({ ...current, [param]: value && value.length !== 0 ? value : null }));

  return (
    <CheckoutEmbedModal
      open={open}
      onClose={onClose}
      iframeId={classesEmbedIframeId(venue.id, filters, values)}
      title={`Classes at ${venue.label}`}
      embedUrl={classesEmbedUrl(venue.embedUrl, filters, values)}
      heading="Embed Classes widget"
      intro="Add these two snippets to your website so people can browse classes and register without leaving it. Pick filters to show only some classes, for example one widget per age group."
      widgetInstructions="Classes widget — paste where you want the class list to appear."
    >
      <div className="classes-embed-filters">
        {venues.length > 1 && (
          <Select
            label="Venue"
            width={200}
            options={venues.map((candidate) => ({ value: String(candidate.id), label: candidate.label }))}
            value={String(venue.id)}
            onChange={(value) => { if (value) setVenueId(String(value)); }}
          />
        )}
        {filters.filter(({ options }) => options.length > 0).map(({ param, label, options, multiple, placeholder }) => (
          <Select
            key={param}
            label={label}
            width={200}
            clearable
            multiple={multiple}
            placeholder={placeholder}
            options={options}
            value={values[param] || (multiple ? [] : null)}
            onChange={(value) => setValue(param, value)}
          />
        ))}
      </div>
    </CheckoutEmbedModal>
  );
}

ClassesEmbedModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  venues: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      label: PropTypes.string,
      embedUrl: PropTypes.string.isRequired,
    })
  ).isRequired,
  filters: PropTypes.arrayOf(embedFilterShape).isRequired,
};
